<template>
  <div class="field-search-container media-select-container">
    <input v-model="searchValue" ref="searchInputRef" class="field-search-input" placeholder="搜索" />
    <div class="field-search-wrap">
      <div class="field-search-list">
        <template v-if="contentList?.length">
          <template v-for="item in contentList" :key="item">
            <fh-divider style="padding: 0 16px" v-if="item?.isFirstTypeOne"></fh-divider>
            <div :disabled="!item.isEnabled" :class="['field-search-item', !item.isEnabled ? 'disabled' : '']" @click.stop="handleSelect(item)">
              <jw-tag size="small" :class="['field-search-item-label']" :style="getTagStyle(item.value)">{{ item.label }}</jw-tag>
              <template v-if="selectedList.find((fItem) => fItem.value == item.value)">
                <icon-check-circle-fill :disabled="item.disabled" class="field-search-item-icon" />
              </template>
            </div>
          </template>
        </template>
        <div v-else>
          <slot name="empty">
            <div class="field-search-item-empty">
              <xl-empty class="empty-text" :msg="$t('没有找到匹配的数据')"></xl-empty>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue';
import fhDivider from '@/components/fh-divider/fh-divider.vue';
const emit = defineEmits(['change']);

const props = defineProps({
  selectedList: {
    type: Array,
    default: () => []
  },
  fieldNames: {
    // 自定义选项中value和label的字段名
    type: Object,
    default: () => ({ value: 'value', label: 'label' })
  },
  options: {
    type: Array,
    default: () => []
  },
  multiple: {
    type: Boolean,
    default: false
  },
  limit: {
    type: Number,
    default: 0
  },
  exceedLimit: {
    type: Function,
    default: undefined
  }
});

const searchValue = ref('');
const searchInputRef = ref(null);

// 标准化选项，确保所有选项都有统一的value和label字段
const formatOptions = computed(() => {
  if (!Array.isArray(props.options) || !props.options.length) return [];
  return props.options.map((option) => ({
    ...option,
    value: option[props.fieldNames.value],
    label: option[props.fieldNames.label],
    disabled: option.disabled
  }));
});

const contentList = computed(() => {
  if (searchValue.value) {
    // 有关键字
    const c = formatOptions.value?.filter((fItem) => fItem.label?.includes(searchValue.value));
    console.log('有关键', c);

    return formatOptions.value?.filter((fItem) => fItem.label?.includes(searchValue.value));
  }
  return formatOptions.value;
});

const selectValues = computed(() => {
  return props.selectedList.map((sItem) => sItem.value);
});

// 获取标签样式
const getTagStyle = (itemValue) => {
  const itemStyle = formatOptions.value.find((item) => item.value === itemValue);
  const tagStyle = {
    backgroundColor: itemStyle?.background,
    color: itemStyle?.color
  };
  return tagStyle;
};

const handleSelect = (item) => {
  // debugger
  if (!item.isEnabled || item.disabled) {
    return;
  }

  if (props.multiple) {
    //多选
    const copyValues = JSON.parse(JSON.stringify(selectValues.value));
    if (copyValues.includes(item.value)) {
      //已经存在
      const idx = copyValues.indexOf(item.value);
      copyValues?.splice(idx, 1);
    } else {
      // 不存在
      copyValues.push(item.value);
    }
    if (props.limit && copyValues?.length > props.limit) {
      props.exceedLimit?.(copyValues);
      return;
    }
    console.log('change', emit);
    emit('change', copyValues);
  } else {
    // 单选模式
    emit('change', item.value);
  }
};

const searchInputFocus = () => {
  nextTick(() => {
    if (searchInputRef.value) {
      searchInputRef.value.focus();
    }
  });
};

defineExpose({ searchInputFocus });
</script>

<style scoped lang="less">
@import './select-content.less';
</style>
